<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <div class="toolbar second-level-toolbar justify-between items-center">

    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="addSectionInRoot()"
                  particleAnalytics
                  analyticsCategory="data-survey"
                  analyticsAction="Add-Section">{{formField && formField.viewType === 'Tab' ? 'Add Tab' : 'Add Section'}}</button>
          <div class="toolbar-separator"></div>
        </div>
        <div *ngIf="formField && formField.viewType === 'Tab'"
             class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="convertTabsToSections()"
                  particleAnalytics
                  analyticsCategory="data-survey"
                  analyticsAction="Add-Section">Convert Into Sections
          </button>
          <div class="toolbar-separator"></div>
        </div>
        <div *ngIf="formField && formField.viewType !== 'Tab'"
             class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="convertSectionsToTabs()"
                  particleAnalytics
                  analyticsCategory="data-survey"
                  analyticsAction="Add-Section">Convert Into Tab
          </button>
          <div class="toolbar-separator"></div>
        </div>
      </div>

    </div>

  </div>
  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">

        <div [ngClass]="containerClass" class="flex flex-col full-grow-no-shrink-no-basis">
          <particle-dynamic-form-container class="particle-dynamic-form-container"
                                           *ngIf="formField && sampleItem && fieldConfig"
                                           [formField]="formField"
                                           [fieldConfig]="fieldConfig"
                                           [sourceType]="sourceType"
                                           [endpointName]="endpointName"
                                           [item]="item"
                                           [showDelete]="showDelete"
                                           [invalidateSubject]="invalidateSubject"
                                           [showLanguageOption]="showLanguageOption"
                                           [designMode]="true"
                                           [editedFields]="editedFields"
                                           (valueChanged)="onValueChanged($event)"
          >

          </particle-dynamic-form-container>

        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>

